import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {interval, Subscription} from 'rxjs';
import {NotificationService} from '../../../../services/notification.service';
import {MatDialog} from '@angular/material/dialog';
import {BacnetDevice} from '../../../../domain/bacnet-device';
import {BacnetDeviceService} from '../../../../services/bacnet-device.service';
import {
  BacnetPreviewUndeployedDatapointsComponent
} from "../bacnet-preview-undeployed-datapoints/bacnet-preview-undeployed-datapoints.component";
import {OPCUADevice} from "../../../../domain/opcua-device";
import {
  DeleteOpcuaDeviceDialogComponent
} from "../../opcua/delete-opcua-device-dialog/delete-opcua-device-dialog.component";
import {DeleteBacnetDeviceDialogComponent} from "../delete-bacnet-device-dialog/delete-bacnet-device-dialog.component";

@Component({
  selector: 'eis-gateway-bacnet-device-table',
  templateUrl: './bacnet-device-table.component.html',
  styleUrls: ['./bacnet-device-table.component.scss']
})
export class BacnetDeviceTableComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @Input()
  public gatewaySerial: string ;

  @Input()
  public tenant: string ;

  @Input()
  public location: string ;

  @Output()
  public deviceSelectedEventEmitter = new EventEmitter<any>();

  // public devices: BacnetDevice[] = [];
  public devicesDataSource = new MatTableDataSource<BacnetDevice>([]);
  public displayedColumns: string[] = ['hasUndeployedDataPoints','online', 'objectName', 'deviceId', 'deviceAddress', 'description', 'vendorName', 'modelName', 'contextActions']

  public selectedDevice: BacnetDevice | undefined;
  public scanningDevices: boolean = false;
  private scanResultSubscription: Subscription | null;
  private readonly scanTimeOutSeconds: number = 10;

  constructor(
    private bacnetService: BacnetDeviceService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.scanResultSubscription?.unsubscribe();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(this.gatewaySerial && this.tenant){
      this.getBacnetDevices()
    }
  }

  ngAfterViewInit() {
    this.devicesDataSource.sort = this.sort
  }

  scanBacnetDevices() {
    this.scanningDevices = true;

    this.devicesDataSource.data = [];

    this.bacnetService.startScanDevice(this.gatewaySerial!, this.scanTimeOutSeconds).subscribe(result => {
      if (result) {
        this.notificationService.success("bacnet-scan-start-success");
        this.getBacnetDevices();
        this.scanResultSubscription = interval(5 * 1000).subscribe(() => this.getBacnetDevices());
      } else {
        this.notificationService.failure("bacnet-scan-start-error");
      }
    }, (error) => {
      this.notificationService.failure(error.error);
      this.scanningDevices = false
    });
  }

  getBacnetDevices() {
    this.selectedDevice = undefined;
    this.bacnetService.getScanResult(this.gatewaySerial,this.tenant).subscribe(scanResult => {
      this.devicesDataSource.data = scanResult.devices;
      this.devicesDataSource.sort = this.sort;
      this.scanningDevices = scanResult.scanStatus != "done";
      if (!this.scanningDevices) {
        this.scanResultSubscription?.unsubscribe();
      }
    });
  }

  deviceSelected2(bacnetDevice: BacnetDevice) {
    this.deviceSelectedEventEmitter.emit(bacnetDevice)
  }

  previewUndeployedChanges() {
    const dialogRef = this.dialog.open(BacnetPreviewUndeployedDatapointsComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: false,
      data: {
        gatewaySerial: this.gatewaySerial,
        tenant: this.tenant,
      },
      width: '900px',
      height: '910px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getBacnetDevices()
    });
  }

  hasChanges() {
    return true
  }

  openDeletionDialog(device: BacnetDevice) {
    const dialogRef = this.dialog.open(DeleteBacnetDeviceDialogComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: {
        gatewaySerial: this.gatewaySerial,
        device: device,
      },
      width: '792px',
      height: '764px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.success) {
        this.getBacnetDevices()
        this.notificationService.success('mbus-delete-device.snackbar.success');

      }
    })
  }

  gatewayHasUndeployedChanges() {
    return this.devicesDataSource.data.find(d => d.hasUndeployedDataPoints)!=null
  }
}
